export enum CallTypesEnums {
  MEETING = "Meeting",
  VIDEO_CALL = "Video Call",
  GROUP_CALL = "Group Call",
}
